<!-- 封装表单上传组件 -->
<template>
    <div>
        <van-cell :title="title" center v-bind="$attrs">
            <template slot="title" v-if="!disable">
                <div class="flex">
                    <span style="margin-right:5px" :class="!disable ? 'van-required' : ''">{{ title }}</span>
                    <info v-if="info" :info="info" />

                </div>
            </template>
            <template slot="label">
                <!--  不同透传 是因为vant库 upload组件中的 imgPriview img的默认事件 -->
                <!-- <upload ref="upload" v-bind="$attrs" v-on="$listeners" :maxCount="maxCount" :showDelete="!disable" /> -->

                <upload :url.sync="sonUrl" :maxCount="maxCount" :showDelete="!disable" />
            </template>
        </van-cell>

    </div>
</template>

<script>
import Upload from "@/components/base/upload/index.vue";
import Info from "@/components/base/info/index.vue";
export default {
    name: 'formUpload',
    props: {
        title: {
            type: String,
            default: '',
            required: true
        },
        disable: {
            type: Boolean,
            default: false,
            required: true
        },
        maxCount: {
            type: Number,
            default: 1,
        },
        url: {
            type: String,
            default: '',
            required: true
        },

        info: {
            type: String,
            default: '',
        }


    },

    components: {
        Upload,
        Info
    },


    watch: {
        url: {
            handler(newValue, oldValue) {
                this.sonUrl = newValue

            },

        },
        sonUrl: {
            handler(newValue, oldValue) {
                if (this.url != newValue) {
                    this.$emit('update:url', newValue)
                }

            },
        }
    },
    data() {
        return {
            sonUrl: ""
        };
    },
    mounted() {


    },

    methods: {}
}

</script>
<style lang="less" scoped>
.van-required::before {
    position: absolute;
    left: 8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}

.flex {
    display: flex;
    align-items: center;
}
</style>